// src/components/BalapKarungVisual.js
import React, { useState, useEffect } from 'react';

// 1. Impor semua aset gambar yang dibutuhkan
import raceTrackImg from '../assets/race-track.png';
import racerLeftStandImg from '../assets/racer-left-stand.png';
import racerLeftHopImg from '../assets/racer-left-hop.png';
import racerRightStandImg from '../assets/racer-right-stand.png';
import racerRightHopImg from '../assets/racer-right-hop.png';

// --- Konfigurasi Statis Game ---
const WINNING_SCORE = 10;
const POSITIONS = {
    left:  { start: 3.5, end: 82 },
    right: { start: 6.5, end: 78 },
};
const ANIMATION_DURATION = 500; // Durasi animasi dalam milidetik (sesuaikan dengan CSS)

/**
 * Custom Hook untuk mengelola kelas animasi sementara.
 * @param {string} status - Status jawaban ('correct' atau 'wrong').
 * @returns {string} - Kelas CSS untuk animasi ('hopping' atau 'shaking').
 */
const useAnimation = (status) => {
    const [animationClass, setAnimationClass] = useState('');

    useEffect(() => {
        // Efek ini hanya berjalan jika 'status' berubah menjadi 'correct' atau 'wrong'
        if (status === 'correct') {
            setAnimationClass('hopping');
        } else if (status === 'wrong') {
            setAnimationClass('shaking');
        } else {
            setAnimationClass(''); // Langsung hapus jika status di-reset
        }

        // Timer untuk menghapus kelas animasi setelah selesai.
        // Ini adalah fallback jika parent tidak me-reset status, tapi perbaikan utama ada di parent.
        if (status) {
            const timer = setTimeout(() => {
                setAnimationClass('');
            }, ANIMATION_DURATION);
            
            // Cleanup function
            return () => clearTimeout(timer);
        }
    }, [status]);

    return animationClass;
};


function BalapKarungVisual({ leftScore, rightScore, leftStatus, rightStatus }) {
    const leftAnimation = useAnimation(leftStatus);
    const rightAnimation = useAnimation(rightStatus);

    const calculatePosition = (score, playerSide) => {
        const { start, end } = POSITIONS[playerSide];
        const progress = score >= WINNING_SCORE ? 1 : score / WINNING_SCORE;
        return start + (end - start) * progress;
    };

    const leftPosition = calculatePosition(leftScore, 'left');
    const rightPosition = calculatePosition(rightScore, 'right');

    // Tentukan apakah gambar 'hop' harus ditampilkan.
    // Gambar 'hop' hanya tampil jika kelas animasinya adalah 'hopping'.
    const isLeftHopping = leftAnimation === 'hopping';
    const isRightHopping = rightAnimation === 'hopping';

    return (
        <div className="game-field balap-karung-field">
            <div className="race-track">
                <img src={raceTrackImg} alt="Lintasan Balap" className="track-image" />

                {/* --- Pembalap Kiri --- */}
                <div
                    className={`racer-container left-racer ${leftAnimation}`}
                    style={{ left: `${leftPosition}%` }}
                >
                    <img
                        src={racerLeftStandImg}
                        alt="Pemain Kiri Berdiri"
                        className="racer-image stand"
                        style={{ display: isLeftHopping ? 'none' : 'block' }}
                    />
                    <img
                        src={racerLeftHopImg}
                        alt="Pemain Kiri Melompat"
                        className="racer-image hop"
                        style={{ display: isLeftHopping ? 'block' : 'none' }}
                    />
                </div>

                {/* --- Pembalap Kanan --- */}
                <div
                    className={`racer-container right-racer ${rightAnimation}`}
                    style={{ left: `${rightPosition}%` }}
                >
                    <img
                        src={racerRightStandImg}
                        alt="Pemain Kanan Berdiri"
                        className="racer-image stand"
                        style={{ display: isRightHopping ? 'none' : 'block' }}
                    />
                    <img
                        src={racerRightHopImg}
                        alt="Pemain Kanan Melompat"
                        className="racer-image hop"
                        style={{ display: isRightHopping ? 'block' : 'none' }}
                    />
                </div>
            </div>
        </div>
    );
}

export default BalapKarungVisual;